import { useQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'
import { apiUrl } from '@/libs/constants'
import { TApiResult } from '@/libs/types/global.types'

export const QUERY_NOTIFICATION_COUNT_KEY = 'notification_count'

type TGetNotificationCountResult = {
  count: number
}

export const getNotificationCount = async () => {
  try {
    const response = await axiosInstance({
      baseURL: apiUrl,
      url: '/notification/count',
    })

    return response?.data
  } catch (error: any) {
    return error?.response?.data
  }
}

const useGetNotificationCountQuery = () => {
  return useQuery<
    undefined,
    TApiResult<TGetNotificationCountResult>,
    TApiResult<TGetNotificationCountResult>,
    [typeof QUERY_NOTIFICATION_COUNT_KEY]
  >({
    queryKey: [QUERY_NOTIFICATION_COUNT_KEY],
    queryFn: () => getNotificationCount(),
    staleTime: 15 * 60000,
  })
}

export default useGetNotificationCountQuery
